import { MockedResponse } from '@apollo/client/testing';
import { DebtorsMetaQuery as DebtorsMetaQueryType } from 'core';
import { DebtorsMetaQuery } from 'core/operations';

export const mockRequestResponse: MockedResponse<DebtorsMetaQueryType> = {
  request: {
    query: DebtorsMetaQuery,
    variables: {
      query: undefined,
      contributionNum: undefined,
    },
  },
  result: {
    data: {
      metaContributions: {
        totalCount: 4,
      },
    },
  },
};
